import React, {
    useContext, useCallback,
} from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { TranslatorContext } from '@jutro/locale';
import { ViewModelForm } from 'gw-portals-viewmodel-react';
import { useCurrency } from 'nfum-portals-utils-react';
import messages from './ProtectingYourValuables.messages';
import metadata from './ProtectingYourValuables.metadata.json5';
import styles from './ProtectingYourValuables.scss';

function ProtectingYourValuables(props) {
    const translator = useContext(TranslatorContext);
    const {
        jobVM,
        value: securityQuestionsVM,
        onValueChange,
    } = props;

    const { formatCurrency } = useCurrency();
    const securityQuestions = _.get(jobVM.value, 'lobData.homeLine.coverables.homhomeProperty.securityQuestions');
    const isMinSecurity = !!securityQuestions?.isMinSecurity;
    const isExtlDoors5LeverMorticeLock = !!securityQuestions?.isExtlDoors5LeverMorticeLock;
    const isAlarmSecurity = !!securityQuestions?.isAlarmSecurity;
    const isSafeCondition = !!securityQuestions?.isSafeCondition;
    const minCashRate = securityQuestions?.minCashRateForSafe ?? 0;
    const lockValues = [
        {
            code: 'MultipointLockingDevice',
            name: translator(messages.multipointLockingDevice),
        },
        {
            code: 'Bs3621Locks',
            name: translator(messages.bs3621Locks),
        },
        {
            code: 'TwoSecurityLocksOfAnyType',
            name: translator(messages.twoSecurityLocksOfAnyType),
        },
        {
            code: 'Other',
            name: translator(messages.other),
        },
    ];

    const alarmValues = [
        {
            code: 'AudibleAnnualMaintenance',
            name: translator(messages.audibleAnnualMaintenance),
        },
        {
            code: 'AudibleNoAnnualMaintenance',
            name: translator(messages.audibleNoAnnualMaintenance),
        },
        {
            code: 'MonitoredNoAnnualMaintenance',
            name: translator(messages.monitoredNoAnnualMaintenance),
        },
        {
            code: 'MonitoredAnnualMaintenance',
            name: translator(messages.monitoredAnnualMaintenance),
        },
        {
            code: 'None',
            name: translator(messages.none),
        },
    ];

    const minCashRateInfo = {
        id: 'quoteandbind.ngh.views.valuables.protectingYourValuables.minCashRateInfo',
        defaultMessage: `In order to protect your valuables, your safe must have a minimum cash rating of ${formatCurrency(minCashRate, false, true)}`
    };

    const handleValueChange = useCallback(
        (value, path) => {
            if (onValueChange) {
                onValueChange(value, path);
            }
        },
        [onValueChange]
    );

    const overrideProps = {
        minSecuritySection: {
            visible: isMinSecurity
        },
        alarmSecuritySection: {
            visible: isAlarmSecurity
        },
        safeConditionSection: {
            visible: isSafeCondition
        },
        safeConditionQuestionInfo1: {
            content: translator(minCashRateInfo)
        },
        lockType: {
            availableValues: lockValues,
            visible: !isExtlDoors5LeverMorticeLock,
            value: securityQuestions?.lockTypeOfExternalDoors
        },
        alarmType: {
            availableValues: alarmValues,
            value: securityQuestions?.intruderAlarmInFullOperation_NFUM
        },
        minSecurityYesOrNo: {
            value: securityQuestions?.externalDoors5LeverMorticeLock
        },
        safeConditionYesOrNo: {
            value: securityQuestions?.isSafeFitted
        },
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveComponentMap: {
        }
    };

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={securityQuestionsVM}
            onValueChange={handleValueChange}
            overrideProps={overrideProps}
            classNameMap={resolvers.resolveClassNameMap}
            componentMap={resolvers.resolveComponentMap}
        />
    );
}

ProtectingYourValuables.propTypes = {
    value: PropTypes.shape({}).isRequired,
    onValueChange: PropTypes.func.isRequired,
};

export default ProtectingYourValuables;
